/**
 * AdminTabNavigation Component
 * Shared tab navigation for admin pages
 * Supports optional badge counts per tab
 */

const AdminTabNavigation = ({ activeTab, onTabChange, tabs }) => (
  <div className="border-b border-gray-200 dark:border-gray-700 mb-4">
    <nav className="flex gap-4" aria-label="Tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          className={`flex items-center gap-2 px-1 py-3 text-sm font-medium border-b-2 transition-colors ${
            activeTab === tab.id
              ? 'border-primary text-primary dark:text-primary-light'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
          }`}
        >
          <tab.icon className="h-4 w-4" />
          {tab.label}
          {tab.badge !== undefined && tab.badge !== null && (
            <span className={`text-xs px-1.5 py-0.5 rounded-full ${
              activeTab === tab.id
                ? 'bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary-light'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
            }`}>
              {tab.badge}
            </span>
          )}
        </button>
      ))}
    </nav>
  </div>
);

export default AdminTabNavigation;
